import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Gumball Poodle (b_1fc44661), pulled from Faire's
// live `GET /api/product-reviews/product/{product_token}` endpoint (review
// token pr_6aug52krve) — verbatim comment, real reviewer first name, location and rating.
export const review_gp7: FaireReviewEntity = {
  token: "review_gp7",
  type: "review",
  brandName: "Gumball Poodle",
  brandToken: "b_1fc44661",
  productToken: "p_6e5f35prgg",
  reviewType: "product",
  reviewerName: "Carlos",
  reviewerLocation: "Provincetown, MA, United States",
  stars: 5,
  reviewText: "One of the most successful products in my store !",
  reviewDate: "Jun 3, 2026",
  meta: {
    source: "api" as const,
    importedAt: "2026-10-12T05:40:00.000Z",
    importedBy: "entity-db-cli",
  },
};
